module.exports = __webpack_public_path__ + "zilky-v-obliceji_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/zilky-v-obliceji_4_after_tn.jpg
// module id = 1467
// module chunks = 0